import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const SuccessTitle = () => <Title title='Success'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>